import { setUserNavigation } from "../reducers/NavigationReducer";

export const SET_USER_NAVIGATION = 'SET_USER_NAVIGATION'

const getfilteredNavigations = (navList = [], role) => {
    return navList.reduce((array, nav) => {

        let navCopy = { ...nav };

        if (navCopy.auth) {
          
            if (navCopy.auth.includes(role.toUpperCase())) {  
                
                if (navCopy.children) {
                    navCopy.children = getfilteredNavigations(navCopy.children, role)
                    array.push(navCopy)
                } else {
                    array.push(navCopy)
                }    
            }
        } else {
            if (navCopy?.children) {
                navCopy.children = getfilteredNavigations(navCopy.children, role)
                array.push(navCopy)
            } else {
                array.push(navCopy)
            }
        }
        // console.log(array); 
        return array
    }, [])
}

// Função para filtrar as navegações com base nas permissões do usuário
const getFilteredNavigationsByProfilePermissions = (navList = [], permissions = [], role) => {
    return navList.reduce((array, nav) => {
        let navCopy = { ...nav };

        // Verifique se a navegação exige permissão para acessar
        if (navCopy.auth) {
            // Verifica se o usuário tem permissão para pelo menos um dos recursos e ações
            const hasPermission = navCopy.auth.name.some((resourceName) =>
                permissions.some((permission) =>
                    permission.resource.name === resourceName &&
                    navCopy.auth.permissions.some((requiredPermission) =>
                        permission.action.name === requiredPermission
                    )
                )
            );

            // Se o usuário tem permissão, adicione a navegação
            if (hasPermission || role == 'admin') {
                if (navCopy.children) {
                    // Recursão para os filhos de navegação
                    navCopy.children = getFilteredNavigationsByProfilePermissions(navCopy.children, permissions, role);
                }
                array.push(navCopy);
            }
        } else {
            // Se não há autenticação necessária, sempre adiciona
            if (navCopy?.children) {
                navCopy.children = getFilteredNavigationsByProfilePermissions(navCopy.children, permissions, role);
                array.push(navCopy);
            } else {
                array.push(navCopy);
            }
        }

        return array;
    }, []);
}

export function getNavigationByUser(user, navigations = []) {

    // Extrair permissões do usuário
    const permissions = user.profile.permissions;

    // Filtra as navegações com base nas permissões do usuário
    let filteredNavigations = getFilteredNavigationsByProfilePermissions(navigations, permissions, user.role)

    // Retorna os dados filtrados para despachar a ação no Redux
    return {
        filteredNavigations
    };
}
